import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useEnhanceInvoiceListSearchFlag = (): boolean =>
  useBooleanFlagValue('enhance-invoice-list-search', false);
